<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <div class="me-2 mb-2">
            <a
              href="javascript:void(0);"
              class="btn btn-white d-inline-flex align-items-center"
              data-bs-toggle="modal"
              data-bs-target="#designation_csv_import_modal"
              v-can="'Designation.Create'"
            >
              <i class="ti ti-file-import me-1"></i>Import
            </a>
          </div>
          <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="exportPDF"
                  >
                    <i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="exportCSV"
                  >
                    <i class="ti ti-file-type-xls me-1"></i>Export as Excel
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="mb-2">
            <a
              href="javascript:void(0);"
              data-bs-toggle="modal"
              data-bs-target="#add_designation"
              class="btn btn-primary d-flex align-items-center"
              v-can="'Designation.Create'"
              ><i class="ti ti-circle-plus me-2"></i>Add Designation</a
            >
          </div>
          <div class="head-icons ms-2">
            <a
              href="javascript:void(0);"
              class=""
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- Designation List -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Designation List</h5>
          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
          >
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                {{ departmentLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="clearDepartment"
                  >
                    All Departments
                  </a>
                </li>
                <li><hr class="dropdown-divider" /></li>
                <li v-for="dept in departmentOptions" :key="dept.id">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="changeDepartment(dept.id)"
                  >
                    {{ dept.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                {{ statusLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="changeStatus('Active')"
                  >
                    Active
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="changeStatus('Inactive')"
                  >
                    Inactive
                  </a>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="changeStatus('')"
                  >
                    All Statuses
                  </a>
                </li>
              </ul>
            </div>

            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Sort By : {{ sortLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setSort('recent')"
                  >
                    Recently Added
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setSort('asc')"
                  >
                    Ascending
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setSort('desc')"
                  >
                    Descending
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setSort('last_month')"
                  >
                    Last Month
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setSort('last_7_days')"
                  >
                    Last 7 Days
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <a-table
              class="table datatable thead-light"
              :columns="columns"
              :data-source="data"
              :loading="loading"
              :row-selection="rowSelection"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'Designation'">
                  <h6 class="fw-medium fs-14 text-dark">
                    {{ record.Designation }}
                  </h6>
                </template>
                <template v-if="column.key === 'Status'">
                  <span
                    :class="[
                      'badge',
                      record.Status === 'Active'
                        ? 'badge-success'
                        : record.Status === 'Inactive'
                        ? 'badge-danger'
                        : 'd-inline-flex',
                      'align-items-center',
                      'badge-xs',
                    ]"
                  >
                    <i class="ti ti-point-filled me-1"></i>
                    {{ record.Status }}
                  </span>
                </template>
                <template v-if="column.key === 'action'">
                  <div class="action-icon d-inline-flex">
                    <a
                      href="javascript:void(0);"
                      class="me-2"
                      data-bs-toggle="modal"
                      data-bs-target="#edit_designation"
                      @click="openEdit(record)"
                      v-can="'Designation.Edit'"
                      ><i class="ti ti-edit"></i
                    ></a>
                    <a
                      href="javascript:void(0);"
                      data-bs-toggle="modal"
                      data-bs-target="#delete_modal"
                      @click="openDelete(record)"
                      v-can="'Designation.Delete'"
                      ><i class="ti ti-trash"></i
                    ></a>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /Designation List -->
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <DesignationsModal ref="designationsModal" @refresh="fetchDesignations" />
  <CsvImportModal
    modal-id="designation_csv_import_modal"
    title="Import Designations from CSV"
    description="Upload a CSV to create designations. Department names must already exist (import departments first)."
    template-hint="Columns: Name, Department, Status (Active/Inactive)."
    template-filename="designation-import-template.csv"
    :columns="importColumns"
    :download-template-fn="downloadDesignationTemplate"
    :preview-fn="previewDesignationImport"
    :apply-fn="applyDesignationImport"
    @imported="onDesignationsImported"
  />
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useDesignationStore } from "@/stores/designationStore";
import { useDepartmentStore } from "@/stores/departmentStore";
import DesignationsModal from "@/components/modal/designations-modal.vue";
import CsvImportModal from "@/components/modal/csv-import-modal.vue";
import designationService from "@/services/hrm/designationService";

const importColumns = [
  { key: "line", title: "Line" },
  { key: "name", title: "Designation" },
  { key: "department", title: "Department" },
  { key: "new_status", title: "Status" },
];

function downloadDesignationTemplate() {
  return designationService.downloadImportTemplate();
}
function previewDesignationImport(file, mode) {
  return designationService.previewImport(file, mode);
}
function applyDesignationImport(file, mode) {
  return designationService.applyImport(file, mode);
}

const columns = [
  { sorter: false },
  {
    title: "Designation",
    dataIndex: "Designation",
    key: "Designation",
    sorter: {
      compare: (a, b) => {
        a = (a.Designation || "").toLowerCase();
        b = (b.Designation || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Department",
    dataIndex: "Department",
    sorter: {
      compare: (a, b) => {
        a = (a.Department || "").toLowerCase();
        b = (b.Department || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "No of Employees",
    dataIndex: "NoofEmployees",
    sorter: {
      compare: (a, b) => {
        const va = Number(a.NoofEmployees || 0);
        const vb = Number(b.NoofEmployees || 0);
        return va - vb;
      },
    },
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
    sorter: {
      compare: (a, b) => {
        a = (a.Status || "").toLowerCase();
        b = (b.Status || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  { title: "", key: "action", sorter: true },
];

// Stores
const designationStore = useDesignationStore();
const departmentStore = useDepartmentStore();

const loading = computed(() => designationStore.loading);
const designationsModal = ref(null);

// 🔹 Filters we send to backend
const filters = ref({
  department_id: "", // numeric id or ""
  status: "", // 'Active' | 'Inactive' | ''
  sort: "recent", // 'recent' | 'asc' | 'desc'
  period: "", // '' | 'last_7_days' | 'last_month' (optional created-at filter)
});

// 🔹 Departments for dropdown
const departmentOptions = computed(() => departmentStore.departments || []);

// 🔹 Department label
const departmentLabel = computed(() => {
  if (!filters.value.department_id) return "Department";
  const d = departmentOptions.value.find(
    (x) => x.id === filters.value.department_id
  );
  return d?.name || "Department";
});

// 🔹 Status label
const statusLabel = computed(() => {
  return filters.value.status || "Select Status";
});

// 🔹 Sort label
const sortLabel = computed(() => {
  if (filters.value.period === "last_7_days") return "Last 7 Days";
  if (filters.value.period === "last_month") return "Last Month";

  if (filters.value.sort === "asc") return "Ascending";
  if (filters.value.sort === "desc") return "Descending";

  return "Recently Added";
});

// Table source: transform backend data to table row shape
const data = computed(() =>
  designationStore.designations.map((item) => ({
    Designation: item?.name,
    Department: item?.department?.name,
    Section: item?.section?.name || "",
    NoofEmployees: item?.employees_count ?? item?.no_of_employees ?? 0, // 🔹 populated via withCount
    Status: item.status,
    id: item.id,
    department_id: item.department_id,
    section_id: item.section_id,
  }))
);

const rowSelection = {
  onChange: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
};

const title = ref("Designations");
const text = ref("Employees");
const text1 = ref("Designations");

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

// 🔹 Central fetch (always uses filters)
function fetchDesignations(force = false) {
  designationStore.fetchDesignations({
    department_id: filters.value.department_id || undefined,
    status: filters.value.status || undefined,
    sort: filters.value.sort || undefined,
    period: filters.value.period || undefined,
    force,
  });
}

function onDesignationsImported() {
  fetchDesignations(true);
}

// 🔹 Change department filter
function changeDepartment(id) {
  filters.value.department_id = id;
  fetchDesignations();
}

// 🔹 Clear department filter
function clearDepartment() {
  filters.value.department_id = "";
  fetchDesignations();
}

// 🔹 Change status
function changeStatus(status) {
  filters.value.status = status;
  fetchDesignations();
}

// 🔹 Sorting & period
function setSort(option) {
  switch (option) {
    case "recent":
      filters.value.sort = "recent";
      filters.value.period = "";
      break;
    case "asc":
      filters.value.sort = "asc";
      filters.value.period = "";
      break;
    case "desc":
      filters.value.sort = "desc";
      filters.value.period = "";
      break;
    case "last_month":
      filters.value.sort = "recent";
      filters.value.period = "last_month";
      break;
    case "last_7_days":
      filters.value.sort = "recent";
      filters.value.period = "last_7_days";
      break;
  }
  fetchDesignations();
}

// Modals
function openEdit(record) {
  designationsModal.value?.openEditModal(record);
}
function openDelete(record) {
  designationsModal.value?.openDeleteModal(record);
}

function exportCSV() {
  designationStore.downloadReport("xlsx", buildExportParams());
}

function exportPDF() {
  designationStore.downloadReport("pdf", buildExportParams());
}

function buildExportParams() {
  return {
    department_id: filters.value.department_id || "",
    status: filters.value.status || "",
    sort: filters.value.sort || "recent",
    period: filters.value.period || "",
  };
}

// Initial load
onMounted(async () => {
  // load departments for dropdown
  await departmentStore.fetchDepartments();
  // then load designations with default filters
  fetchDesignations();
});
</script>


